import { render, staticRenderFns } from "./CheckRecognition.vue?vue&type=template&id=7f51127f&scoped=true"
import script from "./CheckRecognition.vue?vue&type=script&lang=js"
export * from "./CheckRecognition.vue?vue&type=script&lang=js"
import style0 from "./CheckRecognition.vue?vue&type=style&index=0&id=7f51127f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51127f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f51127f')) {
      api.createRecord('7f51127f', component.options)
    } else {
      api.reload('7f51127f', component.options)
    }
    module.hot.accept("./CheckRecognition.vue?vue&type=template&id=7f51127f&scoped=true", function () {
      api.rerender('7f51127f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/identify/CheckRecognition.vue"
export default component.exports